export enum DeliveryTimeType {
    Exact = 'exact',
    Asap = 'asap',
    Window = 'window',
}

export enum DeliveryTypeCategory {
    Delivery = 'delivery',
    Takeaway = 'takeaway',
    EatIn = 'eat_in',
}

export enum Channel {
    Menuboard = 'menuboard',
    Web = 'web',
    QR = 'qr',
    Kiosk = 'kiosk',
    Foodora = 'foodora',
    Wolt = 'wolt',
    Pos = 'pos',
    Phone = 'phone',
    Tab = 'tab',
}

export enum Phase {
    New = 'new',
    InProgress = 'in-progress',
    Future = 'future',
    Archived = 'archived',
}

export enum State {
    AwaitingAcceptance = 'awaiting-acceptance',
    Accepted = 'accepted',
    Production = 'production',
    Ready = 'ready',
    Delivering = 'delivering',
    Delivered = 'delivered',
    Cancelled = 'cancelled',
}

export enum PaymentType {
    CardOnsite = 'card-onsite',
    Cash = 'cash',
    Invoice = 'invoice',
    MealVoucher = 'meal-voucher',
    MealVoucherCard = 'meal-voucher-card',
    Online = 'online',
}
